// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3hOxU","name":"Header_name__LEpHJ","birthday":"Header_birthday__3ZgBo","skeleton":"Header_skeleton___e2NP"};